import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, CreditCard, UserPlus, Users } from 'lucide-react';
import { motion } from 'framer-motion';

interface FamilyDetailHeaderProps {
  familyName: string;
  onBackClick: () => void;
  onAddParentClick: () => void;
  onAddStudentClick: () => void;
  onManageBillingClick: () => void;
  activeTab: string;
}

const FamilyDetailHeader = ({ 
  familyName, 
  onBackClick, 
  onAddParentClick, 
  onAddStudentClick,
  onManageBillingClick,
  activeTab
}: FamilyDetailHeaderProps) => {
  console.log('FamilyDetailHeader rendering with familyName:', familyName);
  
  return (
    <>
      <motion.div variants={itemVariants} className="flex justify-between items-center mb-6">
        <Button variant="ghost" onClick={onBackClick} className="gap-1">
          <ArrowLeft className="h-4 w-4" />
          Back to Families
        </Button>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={onAddParentClick} className="gap-1">
            <UserPlus className="h-4 w-4" />
            Add Parent
          </Button>
          <Button variant="outline" onClick={onAddStudentClick} className="gap-1">
            <UserPlus className="h-4 w-4" />
            Add Student
          </Button>
          {activeTab !== 'billing' && (
            <Button variant="outline" onClick={onManageBillingClick} className="gap-1">
              <CreditCard className="h-4 w-4" />
              Manage Billing
            </Button>
          )}
        </div>
      </motion.div>

      <motion.div variants={itemVariants} className="mb-6">
        <div className="flex items-center gap-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 p-4 rounded-xl shadow-sm">
          <div className="bg-gradient-to-br from-blue-500/20 to-indigo-500/20 p-3 rounded-full">
            <Users className="h-8 w-8 text-blue-600" />
          </div>
          <div className="flex-1">
            <h1 className="text-3xl font-bold text-gray-900 mb-1">
              {familyName || 'Loading...'}
            </h1>
            <p className="text-gray-600 text-sm">Family Management Dashboard</p>
          </div>
        </div>
      </motion.div>
    </>
  );
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] }
  }
};

export default FamilyDetailHeader;
